import { StyledRow, StyledSystemIcon } from "App/global-style";
import styled from "styled-components";

export const ButtonContainer = styled(StyledRow)`
  gap: 8px;
  justify-content: center;

  &:has(> *:nth-child(3)) {
    justify-content: space-between;
  }

  &:not(:has(> *:nth-child(3))) {
    justify-content: flex-start;
    position: relative;

    & > *:nth-child(1) {
      left: 50%;
      position: absolute;
      transform: translateX(-50%);
    }

    & > *:nth-child(2) {
      margin-left: auto;
    }
  }

  & button {
    color: ${({ theme }) =>
      theme.insuranceDetailsCard?.buttonColor ?? theme.brandColors.stbRed};

    svg {
      path {
        fill: ${({ theme }) =>
          theme.insuranceDetailsCard?.buttonColor ?? theme.brandColors.stbRed};
      }
    }
  }

  & button:first-child svg {
    margin-right: 4px;
  }

  & button:not(:first-child) svg {
    margin-left: 4px;
  }
`;

export const ResponsiveSystemIcon = styled(StyledSystemIcon)`
  @media screen and (max-width: 425px) {
    font-size: 16px;
    width: 16px;
  }
`;
